import { Table, Button, Popover } from "antd";
import { CheckOutlined, CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import type { ColumnsType } from "antd/es/table";
// import "../../../src/index.css";
import { Bill, Pagination } from "./Types";
import EditButton from "../UI/EditButton/editbutton";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import ViewButton from "../UI/ViewButton/viewbutton";

interface BillProps {
  selectedRecord: Bill | undefined,
  setSelectedRecord: React.Dispatch<React.SetStateAction<Bill | undefined>>,
  data: Bill[] | undefined;
  isLoading: boolean;
  handleTableChange: React.Dispatch<any>;
  tableKey: number
  pagination: Pagination;
}

const BillsList = ({
  selectedRecord,
  setSelectedRecord,
  data: bills,
  isLoading,
  handleTableChange,
  tableKey,
  pagination
}: BillProps) => {
  const { t } = useTranslation("common");

  const billInfo = (record: Bill) => {
    return (
      <>
        <p>
          {record.isApproved ? (<CheckOutlined style={{ fontSize: "16px" }} className="check-mark"/>) : (<CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />)}
          {" "}
          {t("approved")}
        </p>
        <p>
          {record.isReceived ? (<CheckOutlined style={{ fontSize: "16px", color:"orange" }} className="check-mark"/>) : (<CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />)}
          {" "}
          {t("received")}
        </p>
        <p>
          {record.isPaid ? (<CheckOutlined style={{ fontSize: "16px" }} className="check-mark"/>) : (<CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />)}
          {" "}
          {t("paid")}
        </p>
        <p>
          {record.isPosted ? (<CheckOutlined style={{ fontSize: "16px" }} className="check-mark"/>) : (<CloseOutlined style={{ fontSize: "16px" }} className="x-mark" />)}
          {" "}
          {t("posted")}
        </p>
      </>
    );
  };

  const columns: ColumnsType<Bill> = [
    {
      title: `${t("invoice")}#`,
      width: "10rem",
      key: "invoiceNo",
      render: (record: Bill) => {
        return <>
          {record.invoiceNo}
          <Popover trigger="click" content={billInfo(record)} placement="bottom">
            <Button type="text" className="Button">
              <InfoCircleOutlined />
            </Button>
          </Popover>          
        </>;
      },
    },
    {
      title: `${t("supplier")}`,
      key: "supplier.name",
      align: "center",
      render: (record: Bill) => {
        return <>{record.supplier.name}</>;
      },
    },
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      width: "8rem",
      align: "center",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("due-date")}`,
      dataIndex: "dueDate",
      key: "dueDate",
      width: "8rem",
      align: "center",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("payment-method")}`,
      key: "paymentMode.mode",
      width: "8rem",
      align: "center",
      render: (record: Bill) => {
        return <>{record.paymentMode.mode}</>;
      },
    },
    {
      title: `${t("amount")}`,
      dataIndex: "amountText",
      width: "7rem",
      key: "amountText",
      align: "center",
    },
    {
      title: `${t("discount")}`,
      dataIndex: "discountText",
      width: "7rem",
      key: "discountText",
      align: "center",
    },
    {
      title: `${t("tax")}`,
      dataIndex: "taxText",
      width: "7rem",
      key: "taxText",
      align: "center",
    },
    {
      title: `${t("rate")}`,
      dataIndex: "exchangeRateText",
      width: "7rem",
      key: "exchangeRateText",
      align: "center",
    },
    // {
    //   title: `${t("action")}`,
    //   key: "action",
    //   width: "8rem",
    //   align: "center",
    //   render: (record: any) => (
    //     <>
    //       <ViewButton onClick={() => window.alert(record.id)} />
    //       <EditButton onClick={() => window.alert(record.id)} />
    //       <DeleteButton disabled={!record.canDelete} onClick={() => window.alert(record.id)} />
    //     </>
    //   ),
    // }
  ];

  return (
    <>
      <Table
        scroll={{ x: 1000 }}
        loading={isLoading}
        className="bill"
        key={tableKey}
        dataSource={bills}
        columns={columns}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.id}
        onChange={handleTableChange}
        pagination={{ ...pagination, showSizeChanger: false }}
        rowSelection = {{
          type: "radio",
          columnWidth: 40,
          columnTitle: " ",
          onChange: (selectedRowKeys,selectedRows)=> {
            setSelectedRecord(selectedRows[0])
          }
        }}
      />
    </>
  );
};
export default BillsList;
